import { IconBase } from './IconBase'

type IconPlayArrowProps = React.ComponentProps<'svg'>

export const IconPlayArrow = (props: IconPlayArrowProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path d="M6.555 3.036A1 1 0 0 0 5 3.87V20.13a1 1 0 0 0 1.555.832l12.197-8.13a1 1 0 0 0 0-1.665L6.555 3.036Z" />
    </IconBase>
  )
}
